import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useDocTitle = () => {
  const location = useLocation();
  const defaultTitle = 'Admin Panel';
  const setDocTitle = (newTitle: string) => {
    document.title = `FrontSpot | ${newTitle}` || defaultTitle;
  };

  useEffect(() => {
    switch (location.pathname) {
      case '/tasks/create':
        setDocTitle('Create task');
        break;
      case location.pathname.includes('/tasks/') && location.pathname:
        setDocTitle('Edit task');
        break;
      case '/tasks':
        setDocTitle('Task management');
        break;
      case '/permissions':
        setDocTitle('Permissions');
        break;
      case '/login':
        setDocTitle('Login');
        break;
      case '/forbidden':
        setDocTitle('No access');
        break;
      default:
        setDocTitle('Not found');
    }
  }, [location.pathname]);
};
